import { IdentityModel } from '@core/models/identity.model';

import { BaseModel } from './base.model';
import { InviteModel } from './invite.model';

export class MessageModel extends BaseModel {
  id: string;
  invite: InviteModel;
  isLike: boolean;
  author: IdentityModel;
  authorId: string;
  followers: string[];
  taskId: string;
  projectId: string;
  isPin: boolean;
  likes: string[] = [];
  time: number;
  message: string;
  files: any[] = [];
  createdAt: string;
  updatedAt: string;
  canUpdate: boolean;
}
